module.exports = __webpack_public_path__ + "static/media/logo.0a97186e.png";